var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cashbox-user" }, [
    _c(
      "div",
      { staticClass: "cashbox-user__back" },
      [
        _c(
          "md-button",
          {
            staticClass: "cashbox-user__back-btn md-icon-button",
            on: { click: _vm.closeForm }
          },
          [
            _c("md-icon", [_vm._v("keyboard_arrow_left")]),
            _vm._v(" "),
            _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
              _vm._v(_vm._s(_vm.i18n.lbl_go_back()))
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.closeForm.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "div",
          [
            _vm.isPending
              ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "md-title cashbox-user__title" }, [
              _vm._v(_vm._s(_vm.title()))
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.i18n.lbl_account_info()) + ":")])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "span-account-id" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_id()))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span-account-id-value" }, [
                    _vm._v(_vm._s(_vm.id))
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_email()))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.email))])
                ]),
                _vm._v(" "),
                _vm.accountType
                  ? _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_account_type()))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.accountTypeText()))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.accountStateI
                  ? _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.kyc_current_account_state()))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.accountStateText()))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.accountStateI === _vm.REQUEST_STATES.rejected ||
                _vm.accountStateI === _vm.REQUEST_STATES.permanentlyRejected
                  ? _c("div", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.i18n.lbl_reject_reason()))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.accountRejectReason))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.accountCreated
                  ? _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_created_at()))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.normalizeDate(_vm.accountCreated)))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.accountUpdated
                  ? _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_updated_at()))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.normalizeDate(_vm.accountUpdated)))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.accountType.int === _vm.ACCOUNT_TYPES.general
                  ? [
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.i18n.lbl_user_info()) + ":")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.firstName
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_first_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.firstName))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.lastName
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_last_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.lastName))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.dateOfBirth
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_date_of_birth()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.dateOfBirth))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.idDocumentType
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_document_type()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.idDocumentType))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.idDocumentNumber
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_kyc_id()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.idDocumentNumber))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.documents &&
                        _vm.kyc.documents.kyc_id_document &&
                        _vm.kyc.documents.kyc_id_document.key
                          ? _c(
                              "li",
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.i18n.kyc_copy_passport()) + ":"
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.documents || !_vm.documents.kyc_id_document
                                  ? [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.i18n.lbl_loading()))
                                      ])
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "step__row" },
                                        [
                                          _c("file-field", {
                                            staticClass: "kyc-form__file-field",
                                            attrs: {
                                              id: "kyc-document-photo",
                                              fileType: "image",
                                              label: _vm.i18n.kyc_copy_passport(),
                                              type:
                                                _vm.documentTypes.kycIdDocument
                                            },
                                            model: {
                                              value:
                                                _vm.documents[
                                                  _vm.documentTypes
                                                    .kycIdDocument
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.documents,
                                                  _vm.documentTypes
                                                    .kycIdDocument,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "documents[documentTypes.kycIdDocument]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                              ],
                              2
                            )
                          : _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.kyc_copy_passport()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n.kyc_document_not_attached())
                                )
                              ])
                            ])
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.i18n.kyc_residence_address()) + ":")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.residenceCountry
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_country()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceCountry))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceCity
                          ? _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_city()))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceCity))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceAddress
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_street_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceAddress))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceZipCode
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_zip_code()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceZipCode))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  : _vm.accountType.int === _vm.ACCOUNT_TYPES.syndicate
                  ? [
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.i18n.kyc_general_company_information()) +
                              ":"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.companyName
                          ? _c("li", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n.business_dir_company_name())
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.companyName))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.website
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.kyc_company_website()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.website))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.industry
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.kyc_company_industry()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.industry))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.phoneNumber
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.kyc_company_phone()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.phoneNumber))])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.i18n.kyc_company_legal_address()) + ":"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.country
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_country()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.country))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.city
                          ? _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_city()))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.city))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.street
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_street_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.street))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.zipСode
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_zip_code()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.zipСode))])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.i18n.kyc_company_directors()) + ":")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.firstName
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_first_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.firstName))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.lastName
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_last_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.lastName))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.dateOfBirth
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_date_of_birth()))
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.kyc.dateOfBirth))])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.idDocumentType
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_document_type()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.idDocumentType))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.idDocumentNumber
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_kyc_id()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.idDocumentNumber))
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.i18n.kyc_residence_address()) + ":")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "key-value-list" }, [
                        _vm.kyc.residenceCountry
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_country()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceCountry))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceCity
                          ? _c("li", [
                              _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_city()))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceCity))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceAddress
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_street_name()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceAddress))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kyc.residenceZipCode
                          ? _c("li", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_zip_code()))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.kyc.residenceZipCode))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "md-dialog-actions",
              [
                _c(
                  "md-button",
                  {
                    staticClass: "btn btn_narrow md-primary",
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.i18n.lbl_close()) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e376776", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e376776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/cashbox/index/Cashbox.User.vue
// module id = QgP3
// module chunks = 1